/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-table[_ngcontent-%COMP%]{overflow-x:auto}.mat-header-row[_ngcontent-%COMP%], .mat-row[_ngcontent-%COMP%]{min-width:1100px;width:100%}.statistic[_ngcontent-%COMP%]{background-color:#fff;border-radius:10px;margin:2px;box-shadow:2px 2px gray}table[_ngcontent-%COMP%], tr[_ngcontent-%COMP%]{border:2px solid #000;border-collapse:collapse;width:100%}th[_ngcontent-%COMP%]{border:2px solid #000;font-weight:400;padding:1px}td[_ngcontent-%COMP%]{border:2px solid #b8b8b8;font-family:monospace}.row[_ngcontent-%COMP%]{height:60px}"];
export { styles as styles };
